<template>
  <div>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">Trang chủ</li>
      <li class="breadcrumb-item"><a href=""> Users </a></li>
    </ol>
    <div class="container-fluid">
      <div class="col-sm-10">
        <div class="form-group">
          <router-link to="/admin/user/add" class="btn btn-sm btn-primary">
            <i class="fas fa-plus"></i>
            Thêm mới User
          </router-link>
        </div>
      </div>

      <div>
        <div>
          <div class="row">
          
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-header" v-if="is_loading">
              <SkeletonTheme color="#e6f3fd" highlight="#eef6fd">
                <Skeleton width="40px" height="40"></Skeleton>
              </SkeletonTheme>
            </div>
            <div class="card-header" v-else>
              <i class="fa fa-align-justify" v-if="mydata != null"></i> Quản lý
              Đối tác : ( {{ mydata.length }} )
            </div>
            <div class="card-block">
              <SkeletonTheme color="#e6f3fd" highlight="#eef6fd">
                <table class="table table-sm">
                  <thead>
                    <tr>
                      
                      <th>Thông tin</th>
                      <th>Tên đăng nhập</th>
                      <th>Phân Quyền</th>
                    
                      <th>Quyền hạn</th>
                      <th>Tuỳ chọn</th>
                    </tr>
                  </thead>
                  <tbody v-if="is_loading">
                    <tr v-for="(el, k) in 10" :key="k">
                      <td>
                        <Skeleton width="40px" height="40px"></Skeleton>
                      </td>
                      <td>
                        <Skeleton height="40px"></Skeleton>
                      </td>

                      <td>
                        <Skeleton height="40px"></Skeleton>
                      </td>
                      <td>
                        <Skeleton height="40px"></Skeleton>
                      </td>
                      <td>
                        <Skeleton height="40px"></Skeleton>
                      </td>
                      <td>
                        <a href="" target="_black" class="text text-primary">
                          <Skeleton></Skeleton>
                        </a>
                        <br />

                        <a href="" target="_black" class="text text-primary">
                          <Skeleton></Skeleton>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr
                      v-for="(value, key) in paginationslice(mydata, 10, page)"
                      :Key="key"
                    >
                    
                      <td>
                        Tên: <strong> {{ value.username }}</strong
                        ><br />
                        Email: <strong> {{ value.email }}</strong
                        ><br />
                        Số điện thoại: <strong>{{ value.phone }}</strong
                        ><br />
                      </td>
                      <td>
                        {{ value.name }}
                      </td>
                      <td v-if="my_roles!=null">
                          {{value.roleId | View_Role(my_roles)}}
                      </td>
                      <td>
                        <template v-if="value.isRole == '1'"
                          >System Admin</template
                        >
                        <template v-if="value.isRole == '2'"
                          >Quản trị viên</template
                        >
                        <template v-if="value.isRole == '3'"
                          >Nhân viên</template
                        >
                      </td>
                      <td v-if="id_load !== value.id">
                        <router-link
                          class="btn btn-sm btn-success"
                          v-bind:to="'/admin/user/edit/' + value.id"
                        >
                          <i class="fa fa-edit"></i>
                          Sửa
                        </router-link>
                        <div
                          class="btn btn-sm btn-danger click_remove"
                          @click="removeElement(value.id)"
                          v-if="value.isRole != 1"
                        >
                          <i class="fa fa-remove"></i> Xoá
                        </div>
                      </td>
                      <td v-else>
                        <h4>Loading...</h4>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <nav v-if="mydata != null && mydata.length > 10">
                  <VuePagination
                    :page-count="Math.ceil(mydata.length / 10)"
                    :page-range="3"
                    :margin-pages="2"
                    :click-handler="changePage"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                  >
                  </VuePagination>
                </nav>
              </SkeletonTheme>
            </div>
          </div>
        </div>
        <!--/.col-->
      </div>
    </div>
  </div>
</template>


<script>
import { Skeleton, SkeletonTheme } from "vue-loading-skeleton";
import VuePagination from "vuejs-paginate";
import axios from "axios";
export default {
  name: "News.List",
  data() {
    return {
      is_loading: true,
      form: {},
      mydata: null,
      search: "",
      page: 1,
      id_load: "",
      my_roles:null,
      
    };
  },
  components: {
    Skeleton,
    SkeletonTheme,
    VuePagination,
  },
  filters:{
    
      View_Role(e,r){
            let val=r.filter(v=>v.id==e);

            console.log(e);
              if(val.length>0){
                return val[0].name;
              }
            return 'Đầy đủ';
      }
  },


  mounted() {
    let p1= axios
      .get(window.my_api + "api/user/get-users", {
        headers: {
          language: this.$i18n.locale,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          this.mydata = res.data.data;
          
        } else {
          alert("Hệ thống không hoạt động, vui lòng liên hệ với Admin.");
        }
      });

    let p2= axios
      .get(window.my_api + "api/role/get-roles", {
        headers: {
          language: this.$i18n.locale,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          this.my_roles = res.data.data.filter(v=>v.language=="VN");
         
        } else {
          alert("Hệ thống không hoạt động, vui lòng liên hệ với Admin.");
        }
      });
    

      Promise.all([p1,p2]).then(()=>{
          this.is_loading = false;
      });
  },
  methods: {
    changePage(e) {
      this.page = e;
    },
    paginationslice(data, pagesize, page) {
      return data.filter((value, n) => {
        return n >= pagesize * (page - 1) && n < pagesize * page;
      });
    },
    onSearch() {
      this.is_loading = true;
      axios
        .get(window.my_api + "api/user/get-users?Search=" + this.search, {
          headers: {
            language: this.$i18n.locale,
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.mydata = res.data.data;
            this.page = 1;
          } else {
            alert("Hệ thống không hoạt động, vui lòng liên hệ với Admin.");
          }
          this.is_loading = false;
        });
    },
    removeElement(id) {
      this.$swal
        .fire({
          title: "Bạn có muốn xóa?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.id_load = id;
            axios
              .delete(window.my_api + "api/user/remove-user", {
                data: { userIds: [id] },
              })
              .then((res) => {
                if (res.status == 200) {
                  this.$swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Xóa thành công.",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.mydata = this.mydata.filter((el) => el.id !== id);
                } else {
                  alert(
                    "Hệ thống không hoạt động, vui lòng liên hệ với Admin."
                  );
                }
                this.id_load = "";
              });
          }
        });
    },
  },
};
</script>








